var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5338 1C5.8641 1 1.26709 5.70123 1.26709 11.4994C1.26709 15.7326 2.70924 16.9148 10.4804 28.4352C10.99 29.1883 12.0797 29.1883 12.5893 28.4352C20.3567 16.9132 21.8004 15.732 21.8004 11.4994C21.8004 5.70123 17.2018 1 11.5338 1ZM11.5338 15.825C9.17403 15.825 7.25598 13.8629 7.25598 11.4502C7.25598 9.03754 9.17563 7.07545 11.5338 7.07545C13.8919 7.07545 15.8115 9.03754 15.8115 11.4502C15.8115 13.8629 13.8919 15.825 11.5338 15.825Z",
    stroke: "#CE0E2D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLocationIcon);
export default __webpack_public_path__ + "static/media/home-location-icon.d127e1f6cd5c9f76e7adc59ad5327b71.svg";
export { ForwardRef as ReactComponent };